var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckSolid = function SvgCheckSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.667 9a8.333 8.333 0 1 0 16.666 0A8.333 8.333 0 0 0 .667 9Zm13.045-3.13a.833.833 0 0 0-1.175.085l-4.98 5.756-2.134-2.134a.833.833 0 0 0-1.179 1.179l2.767 2.767a.833.833 0 0 0 1.22-.044l5.566-6.434a.833.833 0 0 0-.085-1.175Z",
    fill: "#fff"
  })));
};

export default SvgCheckSolid;